"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactToastify = require("react-toastify");

var _axios = _interopRequireDefault(require("axios"));

var _formik = require("formik");

var _defaultTranslations = require("./defaultTranslations");

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var Wrapper = function Wrapper(_ref) {
  var translations = _ref.translations,
      onError = _ref.onError,
      onSuccess = _ref.onSuccess,
      onBackClicked = _ref.onBackClicked,
      hideBackButton = _ref.hideBackButton;

  if (!translations) {
    translations = _defaultTranslations.defaultTranslations;
  }

  var onSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values, _ref2) {
      var setSubmitting, res, _response$data, response;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setSubmitting = _ref2.setSubmitting;
              _context.prev = 1;
              _context.next = 4;
              return _axios.default.post("/self-exclusion", values);

            case 4:
              res = _context.sent;
              onSuccess();
              setSubmitting(false);

              _reactToastify.toast.success("".concat(translations.selfExcludedFor, " ").concat(values.duration === 6 ? 6 : values.duration / 12, " ").concat(values.duration === 6 ? "months" : values.duration / 12 > 1 ? "years" : "year"));

              _context.next = 16;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              response = _context.t0.response;

              if (response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.message) {
                _reactToastify.toast.error(response.data.message);
              }

              onError(response);
              setSubmitting(false);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10]]);
    }));

    return function onSubmit(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleBackClicked = function handleBackClicked() {
    onBackClicked();
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.Card, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_formik.Formik, {
      onSubmit: onSubmit,
      initialValues: {
        duration: "6"
      },
      children: function children(_ref5) {
        var values = _ref5.values,
            touched = _ref5.touched,
            handleChange = _ref5.handleChange,
            handleBlur = _ref5.handleBlur,
            handleSubmit = _ref5.handleSubmit,
            isValid = _ref5.isValid,
            isSubmitting = _ref5.isSubmitting;
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_formik.Form, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.Alert, {
            margin: "0 0 1rem",
            children: translations.selfExclusionMessage
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRow, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_fiverReactUiComponents.FormSelect, {
              name: "duration",
              value: values.duration,
              onChange: handleChange,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("option", {
                value: "6",
                children: ["6 ", translations.months]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("option", {
                value: "12",
                children: ["1 ", translations.year]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("option", {
                value: "24",
                children: ["2 ", translations.years]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("option", {
                value: "36",
                children: ["3 ", translations.years]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("option", {
                value: "48",
                children: ["4 ", translations.years]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("option", {
                value: "60",
                children: ["5 ", translations.years]
              })]
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.BlockButton, {
            type: "submit",
            disabled: !isValid || isSubmitting,
            isLoading: isSubmitting,
            children: translations.setSelfExclusion
          }), !hideBackButton && /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.BlockButton, {
            type: "button",
            onClick: handleBackClicked,
            style: {
              marginTop: "1rem"
            },
            isDefault: true,
            children: translations.back
          })]
        });
      }
    })
  });
};

var _default = Wrapper;
exports.default = _default;